import {useState} from "react";
import {useTranslation} from "react-i18next";
import DatePickerModal from "../../../../../../component/global/DatePicker";
import {ReactComponent as CalenderIcon} from "../../../../../../asset/icons/calenderIconGray.svg";

function DetailStatusDateFilter(props) {
  const {t} = useTranslation()
  const [startDate, setStartDate] = useState({
    fa: "",
    en: "",
  });
  const [endDate, setEndDate] = useState({
    fa: "",
    en: "",
  });
  const [startDatePicker, setStartDatePicker] = useState(false);
  const [endDatePicker, setEndDatePicker] = useState(false);

  return (
    <div className='detail-status-date-filter'>
      <div className='detail-status-filter-box'>
        <CalenderIcon/>
      </div>
      <div className='detail-status-date-box'>
        <div className='detail-status-date-item'>
              <span>
              {t("UserPanel.Surveys&announcments.SurveyAnnouncments.FromDate.Label")}
            </span>
          <input
            type=""
            value={startDate.fa}
            onClick={() => setStartDatePicker(true)}
            placeholder={t("UserPanel.dashboard.FeedbackHistoyShowcase.Date.Label")}
            className="date-in"
          />
        </div>
        <div className='detail-status-date-item'>
              <span>
              {t("UserPanel.Surveys&announcments.SurveyAnnouncments.UntillDate.Label")}
            </span>
          <input
            type=""
            value={endDate.fa}
            onClick={() => setEndDatePicker(true)}
            placeholder={t("UserPanel.dashboard.FeedbackHistoyShowcase.Date.Label")}
            className="date-in"
          />
        </div>
      </div>
      <DatePickerModal
        show={startDatePicker}
        close={setStartDatePicker}
        defaultValue={startDate.fa}
        onChange={setStartDate}
      />
      <DatePickerModal
        show={endDatePicker}
        close={setEndDatePicker}
        defaultValue={endDate.fa}
        onChange={setEndDate}
      />
    </div>
  );
}

export default DetailStatusDateFilter;
